var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-secondary text-capitalize"},[(_vm.sourceLabel && _vm.sourceIcon)?_c('span',[_c('i',{staticClass:"text-secondary",class:_vm.sourceIcon}),_vm._v(" "+_vm._s(_vm.sourceLabel)+" ")]):_c('span',[_c('i',{staticClass:"fe fe-x text-muted text-faded text-large"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }